<template>
  <el-dialog
    title="上传"
    :visible.sync="addOtherSecurityTrainingVisible"
    class="small-dialog"
    v-dialogDrag
    :before-close="cancel"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form
      class="clear-placeholer"
      ref="addOtherSecurityTrainingRef"
      label-width="150px"
      :model="addOtherSecurityTrainingForm"
    >
      <el-form-item
        label="培训时间"
        prop="time"
        :rules="[
          {
            required: true,
            message: '请选择培训时间',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-date-picker
          size="small"
          v-model="addOtherSecurityTrainingForm.time"
          type="datetime"
          placeholder="请选择时间"
          clearable
          :disabled="pageConfigType === 'read'"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="培训地点"
        prop="place"
        :rules="[
          {
            required: true,
            message: '请输入培训地点',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="addOtherSecurityTrainingForm.place"
          maxlength="50"
          placeholder="请输入培训地点"
          :disabled="pageConfigType === 'read'"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        label="培训人员"
        prop="memberNamesStr"
        :rules="[
          {
            required: true,
            message: '请选择培训人员',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          size="small"
          v-model="addOtherSecurityTrainingForm.memberNamesStr"
          readonly
          placeholder="请选择"
          class="flex-1"
          :disabled="pageConfigType === 'read'"
        >
          <template slot="append">
            <el-button @click="openTreeSelect" type="primary" :disabled="pageConfigType === 'read'"
              >选择</el-button
            >
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        label="培训内容"
        prop="content"
        :rules="[
          {
            required: true,
            message: '请输入培训内容',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="addOtherSecurityTrainingForm.content"
          maxlength="50"
          placeholder="请输入培训内容"
          :disabled="pageConfigType === 'read'"
        >
        </el-input>
      </el-form-item>

      <el-form-item
        label="培训老师"
        prop="teacher"
        :rules="[
          {
            required: true,
            message: '请输入培训老师',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          v-model="addOtherSecurityTrainingForm.teacher"
          maxlength="50"
          placeholder="请输入培训老师"
          :disabled="pageConfigType === 'read'"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="addOtherSecurityTrainingForm.remark"
          maxlength="50"
          type="textarea"
          rows="3"
          placeholder="请输入备注"
          :disabled="pageConfigType === 'read'"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
    <wiz-tree-select
      :visible.sync="userDialogVisible"
      :treeData="orgUserTree"
      treeCheckField="isActive"
      @save="addUser"
      :defaultSelectKeys="defaultSelectKeys"
      :treeExpandedKeys="treeExpandedKeys"
      title="选择人员"
      treeNodeKey="key"
      repeatKey="id"
      :filterRepeat="true"
      :disabled="false"
    />
  </el-dialog>
</template>
<script>
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'
import { map, cloneDeep, filter, pick, find, chunk, compact } from 'lodash'
import utils from '@/components/safety/enumField/utils'
import {
  WorkPermitAddtionalGuidanceConfigurationDirectoriesApi,
  ContractorApi,
} from '@wiz-api/contractor-management'
import dayjs from 'dayjs'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'

const workPermitAddtionalGuidanceConfigurationDirectorysApi = new WorkPermitAddtionalGuidanceConfigurationDirectoriesApi()
const contractorApi = new ContractorApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  components: {},
  model: {
    prop: 'addOtherSecurityTrainingVisible',
    event: 'addOtherSecurityTrainingChange',
  },
  props: {
    addOtherSecurityTrainingVisible: {
      type: Boolean,
      default: false,
    },
    contractorId: {
      type: String,
      default: '',
    },
    saveOtherSecurityTraining: {
      type: Object,
      default: () => {},
    },
    pageConfigType: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      userDialogVisible: false,
      orgUserTree: [],
      loading: false,
      addOtherSecurityTrainingForm: {
        membersStr: '',
        memberNamesStr: '',
      },
      taskFrequencyType: [],
      workPermitCategoryList: [],
      laborSupliesType: [],
      treeExpandedKeys: [],
      defaultSelectKeys: [],
    }
  },
  watch: {
    saveOtherSecurityTraining: {
      handler(val) {
        if (val.id) {
          this.addOtherSecurityTrainingForm = val
          this.addOtherSecurityTrainingForm.membersStr = val.members.join(',')
          this.addOtherSecurityTrainingForm.memberNamesStr = val.memberNames.join(',')
          if (this.pageConfigType === 'read') {
            clearPlaceholder('.clear-placeholer')
          }
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await utils.getDataCategory(
      ['ContractorManagement.DataCategory.WorkPermitCategory'],
      ['workPermitCategoryList'],
      this
    )
    this.getOrgUserTree()
  },
  methods: {
    processedTreeData(treeData) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = cloneDeep(item)
        cloneTreeItem.label = item.organizationUnitName
        cloneTreeItem.id = item.organizationUnitId
        cloneTreeItem.key = item.organizationUnitId
        let hanldeChildren = []
        if (item.childen && item.childen.length) {
          hanldeChildren = this.processedTreeData(item.childen)
        }
        const activeUserList = filter(item.userList, (user) => {
          return user.isActive
        })
        const userList = map(activeUserList, (user) => {
          return {
            ...user,
            key: `${item.organizationUnitId}-${user.id}`,
            label: user.name,
          }
        })
        delete cloneTreeItem.userList
        delete cloneTreeItem.childen
        cloneTreeItem.children = [...hanldeChildren, ...userList]
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },
    async getOrgUserTree() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({})
      if (!err && res.length) {
        this.orgUserTree = this.processedTreeData(res)
        this.treeExpandedKeys = [res[0].organizationUnitId]
      }
    },
    async addUser(data) {
      const names = []
      const ids = []
      data.forEach((item) => {
        names.push(item.name)
        ids.push(item.id)
      })
      this.addOtherSecurityTrainingForm.memberNamesStr = names.join(',')
      this.addOtherSecurityTrainingForm.membersStr = ids.join(',')
    },
    openTreeSelect() {
      this.defaultSelectKeys = compact(this.addOtherSecurityTrainingForm.membersStr.split(','))
      this.userDialogVisible = true
    },
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    cancel() {
      this.addOtherSecurityTrainingForm = {
        membersStr: '',
        memberNamesStr: '',
      }
      this.$refs.addOtherSecurityTrainingRef.resetFields()
      this.$emit('addOtherSecurityTrainingChange', false)
    },
    save() {
      this.$refs.addOtherSecurityTrainingRef.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.addOtherSecurityTrainingForm.members = this.addOtherSecurityTrainingForm.membersStr.split(
            ','
          )

          this.addOtherSecurityTrainingForm.memberNames = this.addOtherSecurityTrainingForm.memberNamesStr.split(
            ','
          )
          this.addOtherSecurityTrainingForm.time = dayjs(
            this.addOtherSecurityTrainingForm.time
          ).format('YYYY-MM-DD HH:mm:ss')
          if (!this.addOtherSecurityTrainingForm.id) {
            const [err, res] = await contractorApi.createOtherSafetyTraining(this.contractorId, {
              body: this.addOtherSecurityTrainingForm,
            })
            if (!err) {
              this.$message.success('保存成功')
              this.cancel()
            }
          } else {
            const [err, res] = await contractorApi.updateOtherSafetyTraining(
              this.contractorId,
              this.addOtherSecurityTrainingForm.id,
              {
                body: this.addOtherSecurityTrainingForm,
              }
            )
            if (!err) {
              this.$message.success('修改成功')
              this.cancel()
            }
          }

          this.loading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  height: 130px !important;
  width: 440px !important;
  .el-icon-upload {
    margin: 18px 0 16px;
  }
}
.two-row {
  ::v-deep .el-form-item__content {
    margin-right: 0px;
    width: 440px;
    display: flex;
    .el-input-number {
      width: 150px;
      margin-right: 10px;
    }
    .el-select {
      flex: 1;
      .el-input {
        width: 100%;
      }
    }
  }
}
</style>
